import { getRecentItems } from "app/pages/activation/helpers/getRecentItems";
import { useRef, useState } from "react";

import type { ISite } from "@similarweb/ui-components";
import { PixelPlaceholderLoader } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import { AutocompleteWebsitesWithKeysControl } from "app/pages/activation/components/Shared/AutocompleteWebsitesWithKeysControl/AutocompleteWebsitesWithKeysControl";
import { ReadOnlyInput } from "app/components/React/read-only-input/ReadOnlyInput";

import type { SingleWebsiteInputSchema } from "./types";

const HEIGHT = "40px";

export const SingleWebsiteInput = ({
    onClick,
    isLoading,
    selectedWebsite,
    height = HEIGHT,
    placeholder,
    autocompleteProps,
    excludeList,
    isFocused,
    isDisabled,
    className,
}: SingleWebsiteInputSchema) => {
    const autocompleteRef = useRef(null);
    const [isEditMode, setIsEditMode] = useState(false);

    const recent = () => getRecentItems(excludeList);

    const onClickInput = () => setIsEditMode(true);

    const onBlur = () => isEditMode && setIsEditMode(false);
    const onClear = () => setIsEditMode(true);

    const onItemClick = (website: ISite) => {
        onClick(website);
        setIsEditMode(false);
    };

    if (isLoading) {
        return (
            <PixelPlaceholderLoader
                height={height}
                width="100%"
            />
        );
    }

    const isReadOnly = selectedWebsite && (!isEditMode || isDisabled);

    return isReadOnly ? (
        <ReadOnlyInput
            displayText={selectedWebsite.name}
            image={selectedWebsite.image}
            onClearClick={onClear}
            onClick={onClickInput}
            height={HEIGHT}
            disabled={isDisabled}
            className={className}
        />
    ) : (
        <AutocompleteWebsitesWithKeysControl
            renderOnEmptyQuery={recent}
            autocompleteRef={autocompleteRef}
            exclude={excludeList}
            placeholder={translate(placeholder)}
            onItemClick={onItemClick}
            autoFocus={isEditMode}
            onBlur={onBlur}
            isFocused={isFocused}
            {...autocompleteProps}
        />
    );
};
